export const GENERAL_TEXT = Object.freeze({
  common: {
    noOption: 'Sin opción disponible',
    cancel: 'Cancelar',
    clear: 'Limpiar',
    preview: 'Vista previa',
    add: 'Agregar',
    update: 'Actualizar',
    today: 'Hoy',
  },
  status: {
    active: 'Activo',
    inactive: 'Inactivo',
    default: 'Activo',
  },
  yesNo: {
    yes: 'Sí',
    no: 'No',
    empty: '',
  },
  selection: {
    all: 'Todos',
    selectedSuffix: 'seleccionados',
  },
  errors: {
    exchangeRateRequired: 'El tipo de cambio es obligatorio y debe ser mayor a 0',
  },
  financial: {
    totals: {
      subtotal: 'Subtotal',
      total: 'Total',
    },
    taxes: {
      tax: 'Impuesto',
      withoutTaxes: 'Sin impuestos',
      transferred: 'Impuestos trasladados',
      withheld: 'Impuestos retenidos',
      defaultTransferredLabel: 'IVA 16%',
      mode: {
        individual: 'Individual',
        group: 'Grupo',
      },
      section: {
        title: 'Impuestos del concepto',
        subtitle: 'Selecciona el tipo de impuestos aplicables para este concepto.',
        withoutTaxes: 'Sin impuestos',
        taxType: 'Tipo de impuestos',
        taxes: 'Impuestos',
        placeholders: {
          taxes: 'Selecciona impuestos',
          group: 'Selecciona grupo',
        },
        fallbackTaxLabel: ({ id }) => `Impuesto #${id}`,
        fallbackGroupLabel: 'Grupo',
        fallbackIndividualLabel: 'Individual',
      },
    },
  },
});
